
import { TestResult } from "@/hooks/useTestResults";

export const processChartData = (testResults: TestResult[]) => {
  return testResults
    .map(result => ({
      date: new Date(result.created_at).toLocaleDateString(),
      score: result.score,
    }))
    .sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime());
};
